import '../../styles/sections/header/header.scss';
import '../../styles/sections/header/meganav.scss';
import '../../styles/components/predictive-search.scss';
import '../../styles/components/suggestion-item.scss';

import { lazyContent } from '../utils/lazy-content';
import { updateAttributes } from '../utils/cart';

class SiteHeader extends HTMLElement {
  constructor() {
    super();

    this.navLoaded = false;

    this.mobileNavTrigger = this.querySelector('[data-open-mobile-nav]');
    this.desktopNavMenu = this.querySelectorAll('.header__level-1-details > summary');
    this.mobileNav = this.querySelector('[data-mobile-nav]');
    this.announcementBar = this.querySelector('.header__announcement-bar');
    this.mainWrapper = this.querySelector('.header__main-wrapper');

    this.openMobileNavFunction = this.openMobileNav.bind(this);

    this.mobileNavTrigger.addEventListener('click', this.openMobileNavFunction);
    this.desktopNavMenu.forEach((navElement) => {
      navElement.addEventListener('mouseover', this.fetchNav.bind(this));
    });

    /*
      Q: Why does this logic live in the header?
      A: We want this to be checked on every page load, so this could also live in the theme.js file, but we would need to fetch the cart on every page load.
        This way, the cart attributes are checked in the liquid file, and the local storage is only checked when needed.
    */
    if (this.hasAttribute('data-check-local-storage')) {
      this.checkLocalStorage();
    }

    this.headerGroupSections = document.querySelectorAll('.shopify-section-group-header-group');

    window.addEventListener('resize',this.initializeCSSVariables.bind(this));
    window.addEventListener('DOMContentLoaded', this.initializeCSSVariables.bind(this));
  }

  initializeCSSVariables() {
    this.announcementBarHeight = this.announcementBar.offsetHeight;
    this.mainWrapperHeight = this.mainWrapper.offsetHeight;
    this.headerGroupHeight = this.announcementBarHeight + this.mainWrapperHeight;

    document.body.style.setProperty('--header-main-height', `${this.mainWrapperHeight}px`);
    document.body.style.setProperty('--header-main-height-mobile', `${this.mainWrapperHeight}px`);

    this.headerHeight = 0;

    if (this.hasAttribute('data-sticky')) {
      this.childNodes.forEach((child) => {
        if (child.nodeType === Node.ELEMENT_NODE) {
          this.headerHeight += child.offsetHeight;
        }
      });
    }

    this.headerGroupHeight = 0;

    this.headerGroupSections.forEach((headerGroupSection) => {
      this.headerGroupHeight += headerGroupSection.offsetHeight;
    });

    document.body.style.setProperty('--header-height', `${this.headerHeight}px`);
    document.body.style.setProperty('--header-group-height', `${this.headerGroupHeight}px`);
  }

  openMobileNav() {
    this.fetchNav();
  }

  async fetchNav() {
    if (this.navLoaded) {
      return;
    }

    this.navLoaded = true;
    lazyContent(this, '/');
  }

  async checkLocalStorage() {
    if (localStorage.getItem('theme:recentlyViewedProducts')) {
      updateAttributes({
        recentlyViewedProducts: localStorage.getItem('theme:recentlyViewedProducts')
      });
    }
  }
}

customElements.define('site-header', SiteHeader);
